import { connect } from 'react-redux';
import EditSession from './EditSession';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(EditSession);
